/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Upkeep_Desc6Inputs */

const en_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your n8n flows and scripts kept running as APIs change under them.`)
};

const ar_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفقات n8n والسكربتات تبقى تعمل بينما تتغير الواجهات تحتها.`)
};

const bn_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API নিচে বদলালেও আপনার n8n ফ্লো আর স্ক্রিপ্ট চলতে থাকে।`)
};

const de_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre n8n-Flows und Skripte laufen weiter, auch wenn sich APIs darunter ändern.`)
};

const es_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sus flujos de n8n y scripts siguen funcionando aunque las APIs cambien debajo.`)
};

const fr_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos flux n8n et scripts continuent de tourner même quand les API changent en dessous.`)
};

const pt_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os seus fluxos n8n e scripts continuam a correr mesmo quando as API mudam por baixo.`)
};

const zh_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 在底下怎么变，你的 n8n 流程和脚本都照常跑。`)
};

const tr_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API alttan değişse de n8n akışlarınız ve betikleriniz çalışır.`)
};

const ru_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши n8n-флоу и скрипты продолжают работать, даже когда API под ними меняются.`)
};

const pl_svc_retainer_upkeep_desc6 = /** @type {(inputs: Svc_Retainer_Upkeep_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flowy n8n i skrypty działają dalej, nawet gdy API pode spodem się zmieniają.`)
};

/**
* | output |
* | --- |
* | "Your n8n flows and scripts kept running as APIs change under them." |
*
* @param {Svc_Retainer_Upkeep_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_upkeep_desc6 = /** @type {((inputs?: Svc_Retainer_Upkeep_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Upkeep_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_upkeep_desc6(inputs)
	if (locale === "bn") return bn_svc_retainer_upkeep_desc6(inputs)
	if (locale === "de") return de_svc_retainer_upkeep_desc6(inputs)
	if (locale === "es") return es_svc_retainer_upkeep_desc6(inputs)
	if (locale === "fr") return fr_svc_retainer_upkeep_desc6(inputs)
	if (locale === "pt") return pt_svc_retainer_upkeep_desc6(inputs)
	if (locale === "zh") return zh_svc_retainer_upkeep_desc6(inputs)
	if (locale === "tr") return tr_svc_retainer_upkeep_desc6(inputs)
	if (locale === "ru") return ru_svc_retainer_upkeep_desc6(inputs)
	if (locale === "pl") return pl_svc_retainer_upkeep_desc6(inputs)
	return en_svc_retainer_upkeep_desc6(inputs)
});
export { svc_retainer_upkeep_desc6 as "svc_retainer_UPKEEP_desc" }